import React from "react";
import PropTypes from "prop-types";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./EventAssignmentLoader.scss";

const EventAssignmentLoader = ({ testId = "event-assignment-loader" }) => {
  return (
    <div className={classes.loaderContainer} data-test-id={testId}>
      {/* Header section with badge and action icons */}
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <SkeletonLoader width="100%" height="20px" borderRadius="4px" />
        </div>
      </div>

      {/* Body section */}
      <div className={classes.body}>
        {/* Title */}
        <div className={classes.titleSection}>
          <SkeletonLoader width="95%" height="20px" borderRadius="4px" />
        </div>

        {/* Open date section */}
        <div className={classes.dateRow}>
          <div className={classes.dateLabel}>
            <SkeletonLoader width="100%" height="20px" borderRadius="4px" />
          </div>
        </div>

        {/* Due date section */}
        <div className={classes.dateRow}>
          <div className={classes.dateLabel}>
            <SkeletonLoader width="100%" height="20px" borderRadius="4px" />
          </div>
        </div>

        {/* close date section */}
        <div className={classes.dateRow}>
          <div className={classes.dateLabel}>
            <SkeletonLoader width="100%" height="20px" borderRadius="4px" />
          </div>
        </div>

        {/* Separator line */}
        <div className={classes.separator} />

        {/* Class section */}
        <div className={classes.classSection}>
          <div className={classes.classHeader}>
            <SkeletonLoader width="60px" height="20px" borderRadius="4px" />
          </div>
          <SkeletonLoader width="420px" height="20px" borderRadius="4px" />
        </div>
      </div>

      {/* Footer section */}
      <div className={classes.footer}>
        <div className={classes.createdBy}>
          <SkeletonLoader width="36px" height="36px" borderRadius="50%" />
          <div className={classes.creatorInfo}>
            <SkeletonLoader width="80px" height="16px" borderRadius="4px" />
            <SkeletonLoader width="120px" height="18px" borderRadius="4px" />
          </div>
        </div>
        <SkeletonLoader width="120px" height="32px" borderRadius="8px" />
      </div>
    </div>
  );
};

EventAssignmentLoader.propTypes = {
  testId: PropTypes.string,
};

export default EventAssignmentLoader;
